import type { ReactNode, SVGProps } from "react";
export function BeneficiariesIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="14"
			viewBox="0 0 13 14"
			width="13"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M4.82471 7.29159C4.82471 7.64521 4.95114 7.98435 5.17618 8.23439C5.40122 8.48444 5.70645 8.62492 6.02471 8.62492C6.34297 8.62492 6.64819 8.48444 6.87324 8.23439C7.09828 7.98435 7.22471 7.64521 7.22471 7.29159C7.22471 6.93796 7.09828 6.59882 6.87324 6.34878C6.64819 6.09873 6.34297 5.95825 6.02471 5.95825C5.70645 5.95825 5.40122 6.09873 5.17618 6.34878C4.95114 6.59882 4.82471 6.93796 4.82471 7.29159Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M3.625 12.625V11.9583C3.625 11.6047 3.75143 11.2656 3.97647 11.0155C4.20152 10.7655 4.50674 10.625 4.825 10.625H7.225C7.54326 10.625 7.84848 10.7655 8.07353 11.0155C8.29857 11.2656 8.425 11.6047 8.425 11.9583V12.625"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M7.82471 1.95833C7.82471 2.31196 7.95114 2.65109 8.17618 2.90114C8.40122 3.15119 8.70645 3.29167 9.02471 3.29167C9.34297 3.29167 9.64819 3.15119 9.87324 2.90114C10.0983 2.65109 10.2247 2.31196 10.2247 1.95833C10.2247 1.60471 10.0983 1.26557 9.87324 1.01552C9.64819 0.765476 9.34297 0.625 9.02471 0.625C8.70645 0.625 8.40122 0.765476 8.17618 1.01552C7.95114 1.26557 7.82471 1.60471 7.82471 1.95833Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M9.0249 5.29175H10.2249C10.5432 5.29175 10.8484 5.43222 11.0734 5.68227C11.2985 5.93232 11.4249 6.27146 11.4249 6.62508V7.29175"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M1.82471 1.95833C1.82471 2.31196 1.95114 2.65109 2.17618 2.90114C2.40122 3.15119 2.70645 3.29167 3.02471 3.29167C3.34297 3.29167 3.64819 3.15119 3.87324 2.90114C4.09828 2.65109 4.22471 2.31196 4.22471 1.95833C4.22471 1.60471 4.09828 1.26557 3.87324 1.01552C3.64819 0.765476 3.34297 0.625 3.02471 0.625C2.70645 0.625 2.40122 0.765476 2.17618 1.01552C1.95114 1.26557 1.82471 1.60471 1.82471 1.95833Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M0.625 7.29175V6.62508C0.625 6.27146 0.751428 5.93232 0.976472 5.68227C1.20152 5.43222 1.50674 5.29175 1.825 5.29175H3.025"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
		</svg>
	);
}
